import React from 'react'
import {DatePicker, Form, Input, Select} from "antd";
import moment from "moment";

const DiffBetweenOfferShippingFilter = () => {

    const month = 30 * ( 24 * 60 * 60 * 1000 )
    const today = new Date()

    return(
        <React.Fragment>
            <Form.Item
                name={'startDate'}
                label={'Başlangıç Tarihi'}
                initialValue={moment(new Date(today - month))}
                rules={[
                    {required: true, message: 'Bu alan zorunludur'}
                ]}
            >
                <DatePicker format={'DD/MM/YYYY'} />
            </Form.Item>
            <Form.Item
                name={'endDate'}
                label={'Bitiş Tarihi'}
                initialValue={moment(new Date())}
                rules={[
                    {required: true, message: 'Bu alan zorunludur'}
                ]}
            >
                <DatePicker format={'DD/MM/YYYY'} />
            </Form.Item>
            <Form.Item
                name={'bidNo'}
                label={'Teklif No'}
                initialValue={''}
            >
                <Input />
            </Form.Item>
            <Form.Item
                name={'dispatchNo'}
                label={'İrsaliye No'}
                initialValue={''}
            >
                <Input />
            </Form.Item>
            <Form.Item
                name={'stockCode'}
                label={'Stok Kodu'}
                initialValue={''}
            >
                <Input />
            </Form.Item>
            <Form.Item
                name={'createdBy'}
                label={'Oluşturan'}
                initialValue={''}
            >
                <Input />
            </Form.Item>
        </React.Fragment>
    )

}
export default DiffBetweenOfferShippingFilter